webpackJsonp([138],{

/***/ 1172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetail_vue__ = __webpack_require__(2845);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c546dc1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetail_vue__ = __webpack_require__(4836);
function injectStyle (ssrContext) {
  __webpack_require__(4826)
  __webpack_require__(4828)
  this["$style"] = __webpack_require__(4830)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c546dc1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c546dc1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 2005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  props: {
    orderId: [Number, String],
    issueId: [Number, String]
  },
  data: function data() {
    return {
      textarea: '',
      stateOptions: [{
        label: '已经沟通，愿意修改',
        value: 'finish' // -10
      }, {
        label: '已经沟通，放弃修改',
        value: 'giveup' // -10 关闭工单
      }, {
        label: '号码异常，告知推广',
        value: 'finish' // -10
      }, {
        label: '无法联系，下次处理',
        value: 'suspend' // 10
      }],
      statusValue: null,
      table: [],
      getIssueLoading: false,
      addCommentLoading: false,
      openLoading: false,
      loading: false,
      detail: {},
      logs: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    user: function user(state) {
      return state.login.user;
    }
  }), {
    isCurrentUser: function isCurrentUser() {
      return this.detail.master === this.user.id;
    },
    status: function status() {
      return Number(this.detail.status);
    }
  }),
  watch: {
    status: function status(_status) {
      if (_status && _status === 10 && this.isCurrentUser) {
        this.statusValue = 3;
      }
    }
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this = this;

    if (this.issueId > 0) {
      this.loading = true;
      this.loadIssueList(this.issueId).then(function () {
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {},

  methods: {
    loadIssueList: function loadIssueList(id) {
      var _this2 = this;

      return request.all.alert([request('getIssueDetail', { id: id }), request('getIssueLogs', { id: id })]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            detailData = _ref2[0].data,
            logData = _ref2[1].data;

        _this2.detail = detailData;
        _this2.logs = logData;
      });
    },
    open: function open() {
      var _this3 = this;

      this.openLoading = true;
      request.alert('updateIssueOpen', { id: this.detail.id, logString: '客服再次联系' }).then(function () {
        _this3.changeState(30);
        _this3.$message.success('您打开了ISSUE');
      }).finally(function () {
        _this3.openLoading = false;
      });
    },
    create: function create() {
      return request.alert('createIssue', { order_id: this.orderId, logString: this.textarea });
    },
    addLog: function addLog(content) {
      this.logs = [{
        operationtime: filter.formatDate(), operator: this.user.name, content: content
      }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.logs));
      this.textarea = '';
    },
    addComment: function addComment() {
      var _this4 = this;

      this.addCommentLoading = true;
      // 已存在issue
      if (this.detail.id) {
        request.alert('addIssueComment', { id: this.detail.id, logString: this.textarea }).then(function () {
          _this4.addLog(_this4.textarea);
          _this4.$message.success('添加了一条ISSUE评论');
        }).finally(function () {
          _this4.addCommentLoading = false;
        });
      } else {
        // 创建新issue
        this.create().then(function (_ref3) {
          var data = _ref3.data;

          // 重新获得issue详情
          request.alert('getIssueDetail', { id: data.id }).then(function (_ref4) {
            var data = _ref4.data;

            _this4.detail = data;
            _this4.addLog(_this4.textarea);
          });
        }).finally(function () {
          _this4.addCommentLoading = false;
        });
      }
    },
    getIssue: function getIssue() {
      var _this5 = this;

      this.getIssueLoading = true;
      request.alert('updateIssueUser', { id: this.detail.id, logString: '领取ISSUE' }).then(function () {
        _this5.changeState(20, _this5.user.id);
        _this5.$message.success('已领取ISSUE');
      }).finally(function () {
        _this5.getIssueLoading = false;
      });
    },
    changeState: function changeState(status, master) {
      if (this.detail.status !== status) {
        var detail = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.detail, {
          status: status
        });
        if (master) {
          detail.master = master;
        }
        this.detail = detail;
      }
    },
    onChangeState: function onChangeState(index) {
      var _this6 = this;

      var text = this.stateOptions[index].label;
      switch (this.stateOptions[index].value) {
        case 'finish':
          this.loading = true;
          request.alert('updateIssueFinish', { id: this.detail.id, logString: text }).then(function () {
            _this6.addLog(text);
            _this6.changeState(-10);
            _this6.statusValue = index;
            _this6.loading = false;
          });
          break;
        case 'giveup':
          this.$confirm('放弃修改后, 系统将收回工单，是否确认?', '提示', {
            type: 'warning'
          }).then(function () {
            _this6.loading = true;
            request.alert('updateIssueFinishAndOrderNotPassed', {
              id: _this6.detail.id,
              order_id: _this6.orderId,
              logString: text
            }).then(function () {
              _this6.addLog(text);
              _this6.changeState(-10);
              _this6.statusValue = index;
              _this6.loading = false;
            });
          });
          break;
        case 'suspend':
          this.loading = true;
          request.alert('updateIssueWait', { id: this.detail.id, logString: text }).then(function () {
            _this6.addLog(text);
            _this6.changeState(10);
            _this6.statusValue = index;
            _this6.loading = false;
          });
          break;
      }
    }
  }
});

/***/ }),

/***/ 2337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(2005);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1d9a630_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2340);
function injectStyle (ssrContext) {
  __webpack_require__(2338)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1d9a630"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1d9a630_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2338:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2339);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2eec448e", content, true, {});

/***/ }),

/***/ 2339:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".issue-list[data-v-d1d9a630]{background-color:#f9fafc;padding:10px}.issue-list p[data-v-d1d9a630]{margin:0}.issue-list .issue-date[data-v-d1d9a630]{font-size:10px;color:#909399}", "", {"version":3,"sources":["/workspace/src/views/issue/components/IssueLighter/index.vue"],"names":[],"mappings":"AACA,6BAA6B,yBAAyB,YAAY,CACjE,AACD,+BAA+B,QAAU,CACxC,AACD,yCAAyC,eAAe,aAAa,CACpE","file":"index.vue","sourcesContent":["\n.issue-list[data-v-d1d9a630]{background-color:#f9fafc;padding:10px\n}\n.issue-list p[data-v-d1d9a630]{margin:0px\n}\n.issue-list .issue-date[data-v-d1d9a630]{font-size:10px;color:#909399\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('div',[(!_vm.isCurrentUser && _vm.status === -10)?_c('div',[_c('el-tag',{attrs:{"type":"info","size":"medium"}},[_vm._v("admin已处理这个issue\n        ")])],1):_c('div',{directives:[{name:"permission",rawName:"v-permission",value:(226),expression:"226"}]},[(_vm.detail.id)?_c('div',[(!_vm.isCurrentUser || [30].includes(_vm.status))?_c('el-button',{attrs:{"type":"success","size":"mini","loading":_vm.getIssueLoading},on:{"click":_vm.getIssue}},[_vm._v("领取\n          ")]):_vm._e(),_vm._v(" "),(_vm.isCurrentUser && [10,20].includes(_vm.status))?_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("已领取\n          ")]):_vm._e(),_vm._v(" "),_c('el-select',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCurrentUser && [10,20].includes(_vm.status)),expression:"isCurrentUser && [10,20].includes(status)"}],staticStyle:{"width":"100%","margin-top":"15px"},attrs:{"value":_vm.statusValue,"placeholder":"请选择处理选项","size":"mini"},on:{"change":_vm.onChangeState}},_vm._l((_vm.stateOptions),function(item,index){return _c('el-option',{key:item.label,attrs:{"label":item.label,"value":index}})}),1),_vm._v(" "),_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:([-10, -20].includes(_vm.status)),expression:"[-10, -20].includes(status)"}],attrs:{"type":"info","size":"medium"}},[_vm._v("您已处理这个issue\n          ")])],1):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"permission",rawName:"v-permission",value:(225),expression:"225"},{name:"show",rawName:"v-show",value:([-10,-20].includes(_vm.status)),expression:"[-10,-20].includes(status)"}],staticStyle:{"margin-top":"15px"}},[_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.openLoading),expression:"openLoading"}],attrs:{"type":"info","size":"mini"},on:{"click":function($event){return _vm.open()}}},[_vm._v("客服再次联系\n      ")])],1),_vm._v(" "),_c('el-input',{staticStyle:{"margin-top":"15px"},attrs:{"type":"textarea","autosize":"","placeholder":"请输入评论内容","size":"mini"},model:{value:(_vm.textarea),callback:function ($$v) {_vm.textarea=$$v},expression:"textarea"}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px"}},[_c('el-button',{attrs:{"type":"primary","size":"mini","disabled":!_vm.textarea,"loading":_vm.addCommentLoading},on:{"click":function($event){return _vm.addComment()}}},[_vm._v("\n        添加评论\n      ")])],1)],1),_vm._v(" "),_vm._l((_vm.logs),function(ref){
var operationtime = ref.operationtime;
var operator = ref.operator;
var content = ref.content;
return _c('div',{staticClass:"issue-list",staticStyle:{"margin-top":"15px"}},[_c('p',{staticClass:"issue-date"},[_vm._v(_vm._s(operationtime))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(operator)+": ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block"},domProps:{"innerHTML":_vm._s(content)}})])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_issue_components_IssueLighter__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_order_components_OrderMemoUpdate__ = __webpack_require__(4832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_order_components_OrderFaceVerified__ = __webpack_require__(4834);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { OrderMemoUpdate: __WEBPACK_IMPORTED_MODULE_4__views_order_components_OrderMemoUpdate__["a" /* default */], IssueLighter: __WEBPACK_IMPORTED_MODULE_3__views_issue_components_IssueLighter__["a" /* default */], OrderFaceVerified: __WEBPACK_IMPORTED_MODULE_5__views_order_components_OrderFaceVerified__["a" /* default */] },
  data: function data() {
    return {
      orderid: null,
      filter: false,
      data: {},
      face_verified_image: null,
      scoredFaceList: [],
      table: [{
        key: 'orderid',
        label: '工单ID',
        value: ''
      }, {
        key: 'strstatus',
        label: '工单状态',
        value: ''
      }, {
        key: 'cacheuploadstatus',
        label: '任务缓存状态',
        value: ''
      }, {
        key: 'taskid',
        label: '所属任务ID',
        value: ''
      }, {
        key: 'title',
        label: '任务标题',
        value: ''
      }, {
        key: 'strtype',
        label: '任务类型',
        value: ''
      }, {
        key: 'taskmarketareaid',
        label: '任务区域',
        value: ''
      }, {
        key: 'salary',
        label: '赏金',
        value: ''
      }, {
        key: 'managementfee',
        label: '管理费',
        value: ''
      }, {
        key: 'points',
        label: '积分',
        value: ''
      }, {
        key: 'validcheckindistance',
        label: '有效签到距离',
        value: ''
      }, {
        key: 'showtime',
        label: '任务预览开始时间',
        value: ''
      }, {
        key: 'starttime',
        label: '任务上线时间',
        value: ''
      }, {
        key: 'deadline',
        label: '任务下线时间',
        value: ''
      }, {
        key: 'taskendtime',
        label: '任务结束时间',
        value: ''
      }, {
        key: 'endtime',
        label: '用户最晚完成时间',
        value: ''
      }, {
        key: 'processingtime',
        label: '任务最晚完成时间限制(小时)',
        value: ''
      }, {
        key: 'reviewtime',
        label: '审核时间(天)',
        value: ''
      }, {
        key: 'availableTime',
        label: '任务可执行时间',
        value: ''
      }, {
        key: 'clientversion',
        label: '用户App版本',
        value: ''
      }, {
        key: 'clientosversion',
        label: '用户手机OS版本',
        value: ''
      }, {
        key: 'clientmodel',
        label: '用户手机型号',
        value: ''
      }, {
        key: 'devicenum',
        label: '用户设备号',
        value: ''
      }, {
        key: 'uservietime',
        label: '用户抢单时间',
        value: ''
      }, {
        key: 'userstarttime',
        label: '用户开始时间',
        value: ''
      }, {
        key: 'userfinishtime',
        label: '用户完成时间',
        value: ''
      }, {
        key: 'str_start_app_type',
        label: '签到平台',
        value: ''
      }, {
        key: 'str_finish_app_type',
        label: '提交平台',
        value: ''
      }, {
        key: 'content',
        label: '任务详细描述',
        value: ''
      }, {
        key: 'seriestasktemplateid',
        label: '系列任务模板ID',
        value: ''
      }, {
        key: 'templateid',
        label: '任务模板ID',
        value: ''
      }, {
        key: 'customername',
        label: '客户编号',
        value: ''
      }, {
        key: 'projectname',
        label: '项目编号',
        value: ''
      }, {
        key: 'batchname',
        label: '批次编号',
        value: ''
      }, {
        key: 'gpsCheck',
        label: '任务提交是否验证GPS位置',
        value: ''
      }, {
        key: 'personface_verify',
        label: '人脸验证',
        value: ''
      }, {
        key: 'priority',
        label: '任务是否置顶',
        value: ''
      }, {
        key: 'superuserprior',
        label: '是否金牌人员优先',
        value: ''
      }, {
        key: 'onlynearby',
        label: '是否不在任务大厅显示',
        value: ''
      }, {
        key: 'multitimes',
        label: '是否准许多次接单',
        value: ''
      }, {
        key: 'addto_taskgroup_target_num',
        label: '自动群组目标数标记任务',
        value: ''
      }, {
        key: 'rejectuserrepeat',
        label: '审核不通过时用户是否可重复执行',
        value: ''
      }, {
        key: 'ostype',
        label: '发布平台',
        value: ''
      }, {
        key: 'marketname',
        label: '任务所属商场',
        value: ''
      }, {
        key: 'provincename',
        label: '任务城市',
        value: ''
      }, {
        key: 'address',
        label: '门店地址',
        value: ''
      }, {
        key: 'marketinfo',
        label: '任务位置',
        value: ''
      }, {
        key: 'hirenum',
        label: '需要人数',
        value: ''
      }, {
        key: 'blackList',
        label: '黑名单',
        value: ''
      }, {
        key: 'blackListTags',
        label: '黑名单标签',
        value: ''
      }, {
        key: 'whiteList',
        label: '白名单',
        value: ''
      }, {
        key: 'whiteListTags',
        label: '白名单标签',
        value: ''
      }, {
        key: 'photo',
        label: '任务照片',
        value: ''
      }, {
        key: 'adminname',
        label: '添加管理员',
        value: ''
      }, {
        key: 'first_reviewer',
        label: '初审管理员',
        value: ''
      }, {
        key: 'userprocesslog',
        label: '用户操作日志',
        value: ''
      }, {
        key: 'adminprocesslog',
        label: '管理员操作日志',
        value: ''
      }, {
        key: 'templatejson',
        label: '模板任务完成情况',
        value: ''
      }, {
        key: 'str_training_instruction',
        label: '关联培训',
        value: ''
      }, {
        key: 'str_training_knowledge',
        label: '关联培训知识库',
        value: ''
      }, {
        key: 'face_verified',
        label: '工单人脸验证状态',
        value: ''
      }, {
        key: 'face_verified_times',
        label: '工单人脸验证次数',
        value: ''
      }, {
        key: 'face_verified_image',
        label: '零工提交人脸验证照片',
        value: ''
      }, {
        key: 'checkinlocation',
        label: '任务签到GPS位置',
        value: ''
      }, {
        key: 'finishlocation',
        label: '任务完成后GPS位置',
        value: ''
      }, {
        key: 'userid',
        label: '任务完成人',
        value: ''
      }, {
        key: 'errormessage',
        label: '审核不通过原因',
        value: ''
      }, {
        key: 'memo',
        label: '备忘',
        value: ''
      }, {
        key: 'taskQuality',
        label: '任务完成质量',
        value: ''
      }, {
        key: 'taskEfficiency',
        label: '任务完成速度',
        value: ''
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), {
    templateTitle: function templateTitle() {
      if (this.data.templatejson === null) {
        return '';
      } else if (typeof this.data.templatejson === 'string') {
        return JSON.parse(this.data.templatejson).title;
      }
      return this.data.templatejson.title;
    }
  }),
  created: function created() {
    this.orderid = this.$route.params.orderid;
    this.orderid > 0 && this.setDetailData(this.orderid);
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    setDetailData: function setDetailData(id) {
      var _this = this;

      request.page('getOrderDetailInfo', { id: id }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
          var data = _ref2.data;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.data = data;

                  if (_this.data.userinfo) {
                    _this.data.clientversion = _this.data.userinfo.clientversion;
                    _this.data.clientmodel = _this.data.userinfo.clientmodel;
                    _this.data.devicenum = _this.data.userinfo.devicenum;
                  } else {
                    _this.data.clientversion = '';
                    _this.data.clientmodel = '';
                    _this.data.devicenum = '';
                  }

                  _this.table.forEach(function (obj) {
                    if (data.hasOwnProperty(obj.key)) {
                      obj.value = data[obj.key];
                      if (obj.key === 'personface_verify' && obj.value === 0) {
                        _this.filter = true;
                      }
                      if (obj.key === 'face_verified_image') {
                        _this.face_verified_image = obj.value;
                      }
                    }
                  });

                  if (!_this.filter) {
                    _context.next = 7;
                    break;
                  }

                  _this.table = _this.table.filter(_this.filterTable);
                  _context.next = 9;
                  break;

                case 7:
                  _context.next = 9;
                  return request.common('getOrderScoredFaceListApi', { orderid: id }).then(function (res) {
                    if (res.data.length > 0) {
                      _this.scoredFaceList = res.data;
                      if (_this.face_verified_image) {
                        var imagePath = function imagePath(url) {
                          return url.replace(/^https?:\/\/[^/]+/, '');
                        };
                        if (imagePath(_this.scoredFaceList[0].faceimage) !== imagePath(_this.face_verified_image)) {
                          _this.scoredFaceList.unshift({
                            faceimage: _this.face_verified_image,
                            face_score: '最新一次验证,无分数'
                          });
                        }
                      }
                    }
                  });

                case 9:
                  // 门店任务 显示门店地址
                  if (data.hasOwnProperty('marketid') && data.marketid === 0) {
                    _this.table = _this.table.filter(function (item) {
                      return item.key !== 'address';
                    });
                  }

                case 10:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    ifSelect: function ifSelect(scope) {
      var item = ['cacheuploadstatus', 'taskmarketareaid', 'gpsCheck', 'priority', 'inhouseprior', 'superuserprior', 'multitimes', 'rejectuserrepeat', 'rejecttaskrepeat', 'ostype', 'onlynearby'];
      for (var i = 0; i < item.length; i++) {
        if (scope.row.key === item[i]) {
          return true;
        }
      }
      return false;
    },
    formatUnix: function formatUnix(time) {
      return filter.formatUnix(time);
    },
    forcePass: function forcePass() {
      var _this2 = this;

      var detail = { orderid: this.orderid };
      request.common('orderVerifyFaceEnforce', detail).then(function (res) {
        _this2.$message('手动通过成功！');
      });
    },
    filterTable: function filterTable(element) {
      return element.key !== 'face_verified' && element.key !== 'face_verified_times' && element.key !== 'face_verified_image';
    },
    salaryValue: function salaryValue(value) {
      return filter.hasPermission(250) ? value : '*';
    }
  })
});

/***/ }),

/***/ 2846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    orderid: {
      type: Number,
      value: 0
    },
    memo: {
      type: String,
      value: ''
    }
  },
  data: function data() {
    return {
      content: this.memo
    };
  },

  watch: {
    memo: function memo() {
      if (this.memo !== this.content) {
        this.content = this.memo;
      }
    }
  },

  methods: {
    onUpdateOrderMemo: function onUpdateOrderMemo() {
      var _this = this;

      var detail = {
        memo: this.content,
        orderid: this.orderid
      };

      request.common('updateOrderMemo', detail).then(function (res) {
        _this.$message('更新备忘成功！');
      });
    }
  }
});

/***/ }),

/***/ 2847:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_viewerjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    orderid: {
      type: Number,
      value: 0
    },
    image: {
      type: String,
      value: ''
    },
    scoredFaceList: {
      type: Array,
      value: function value() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      pic: []
    };
  },

  watch: {},

  methods: {
    displayPhotos: function displayPhotos() {
      var _this = this;

      var detail = {
        orderid: this.orderid
      };
      request.common('getOrderFaceList', detail).then(function (res) {
        _this.pic = res.data;
        if (res.data.length) {
          _this.visible = true;
        } else {
          _this.$message('无人脸验证照片');
        }
      });
    },
    onViewImage: function onViewImage(event) {
      if (!this.views) {
        this.views = new __WEBPACK_IMPORTED_MODULE_1_viewerjs___default.a(event.target, {
          url: function url(image) {
            return event.target.src;
          }
        });
      }
      this.views.view();
    }
  }
});

/***/ }),

/***/ 4826:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4827);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7b95ed41", content, true, {});

/***/ }),

/***/ 4827:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4828:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4829);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("69f5f40a", content, true, {});

/***/ }),

/***/ 4829:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "a[data-v-c546dc1a]{text-decoration:none}.blue-color[data-v-c546dc1a]{color:#589df8}", "", {"version":3,"sources":["/workspace/src/views/order/pages/OrderDetail.vue"],"names":[],"mappings":"AACA,mBAAmB,oBAAoB,CACtC,AACD,6BAA6B,aAAa,CACzC","file":"OrderDetail.vue","sourcesContent":["\na[data-v-c546dc1a]{text-decoration:none\n}\n.blue-color[data-v-c546dc1a]{color:#589df8\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4830:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4831);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("11ec0b92", content, true, {});

/***/ }),

/***/ 4831:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderMemoUpdate_vue__ = __webpack_require__(2846);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf31205_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderMemoUpdate_vue__ = __webpack_require__(4833);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderMemoUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf31205_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderMemoUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"type":"textarea","autosize":"","placeholder":"请输入备忘"},on:{"change":function (value){ return _vm.$emit('input',value); }},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.onUpdateOrderMemo}},[_vm._v("更新备忘\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4834:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderFaceVerified_vue__ = __webpack_require__(2847);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91cd971a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderFaceVerified_vue__ = __webpack_require__(4835);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderFaceVerified_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91cd971a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderFaceVerified_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"16px"}},_vm._l((_vm.scoredFaceList),function(item){return _c('div',{key:item.faceimage,staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('img',{staticClass:"avatar",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":item.faceimage}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.face_score))])])}),0),_vm._v(" "),(_vm.image && _vm.scoredFaceList.length < 1)?_c('img',{staticClass:"avatar",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.image}}):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.displayPhotos}},[_vm._v("展示所有")]),_vm._v(" "),_c('el-dialog',{staticStyle:{"margin-left":"10px"},attrs:{"title":"人脸照片","visible":_vm.visible,"width":"50%"},on:{"update:visible":function($event){_vm.visible=$event}}},[_vm._l((_vm.pic),function(item){return [_c('img',{staticStyle:{"width":"200px"},attrs:{"src":item},on:{"click":_vm.onViewImage}})]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/order/table"}},[_vm._v("任务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":18}},[_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-table',{staticClass:"margin b15",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","show-header":false}},[_c('el-table-column',{attrs:{"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.key === 'marketname')?_c('b',[_vm._v(_vm._s(_vm.data.type * 1 === 23 ? '宴席订单编号' : scope.row.label))]):_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.ifSelect(scope))?_c('span',_vm._l((_vm.options[scope.row.key]),function(item){return (scope.row.value === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()}),0):(scope.row.key === 'strstatus')?_c('span',[_vm._v("\n                "+_vm._s(scope.row.value)),(_vm.data.cancelmessage && scope.row.value === '已关闭')?_c('span',[_vm._v("(放弃原因:"+_vm._s(_vm.data.cancelmessage)+")")]):_vm._e()]):(scope.row.key === 'salary')?_c('span',[_vm._v("\n              "+_vm._s(_vm.salaryValue(scope.row.value))+"元\n              ")]):(scope.row.key === 'managementfee' )?_c('span',[_vm._v("\n              "+_vm._s(scope.row.value)+"元\n              ")]):(scope.row.key === 'points')?_c('span',[_vm._v("\n              "+_vm._s(scope.row.value)+"零豆\n              ")]):(scope.row.key === 'validcheckindistance')?_c('span',[_vm._v("\n              "+_vm._s(scope.row.value)+"公里\n              ")]):(scope.row.key === 'taskid')?_c('router-link',{attrs:{"to":'/task/detail/'+_vm.data.taskid}},[_c('span',{staticClass:"blue-color"},[_vm._v("TSK"+_vm._s(scope.row.value))])]):(scope.row.key === 'templateid')?[(_vm.data.templateid !== 0)?_c('router-link',{attrs:{"to":'/step-template/update/'+_vm.data.templateid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.templateTitle)+"/"+_vm._s(scope.row.value))])]):_vm._e()]:(scope.row.key === 'customername')?_c('span',[_c('router-link',{attrs:{"to":'/order/table?customerid='+_vm.data.customerid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.data.customername))])])],1):(scope.row.key === 'projectname')?_c('span',[_c('router-link',{attrs:{"to":'/order/table?projectid='+_vm.data.projectid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.data.projectname))])])],1):(scope.row.key === 'batchname')?_c('span',[_c('router-link',{attrs:{"to":'/order/table?batchid='+_vm.data.batchid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.data.batchname))])])],1):(scope.row.key === 'marketname')?_c('span',[_c('router-link',{attrs:{"to":'/market/table?id='+_vm.data.marketid,"target":"_blank"}},[(_vm.data.type * 1 === 23)?_c('span',[_vm._v(_vm._s(_vm._f("sjfmarketname")(_vm.data.marketname,_vm.data.type)))]):_c('span',[_vm._v(_vm._s(((_vm.data.marketname) + "/" + (_vm.data.marketid))))])])],1):(scope.row.key === 'provincename')?_c('span',[_c('span',[_vm._v(_vm._s(_vm.data.provincename)+_vm._s(_vm.data.cityname)+_vm._s(_vm.data.areaname))])]):(scope.row.key === 'marketinfo')?_c('span',[_c('span',[_vm._v(_vm._s(_vm.data.latitude)+","+_vm._s(_vm.data.longitude))]),_c('br')]):(scope.row.key === 'address' && _vm.data.marketid > 0)?_c('span',[(_vm.data.marketinfo && _vm.data.marketinfo.address)?_c('span',[_vm._v(_vm._s(_vm.data.marketinfo.address))]):_vm._e(),_c('br')]):(scope.row.key === 'hirenum')?_c('span',[_c('span',[_vm._v(_vm._s(scope.row.value)+"人")])]):(scope.row.key === 'blackList' || scope.row.key === 'whiteList')?_c('span',_vm._l((scope.row.value),function(item){return _c('span',{staticClass:"blue-color"},[_c('router-link',{attrs:{"to":'/users/detail/info?userid='+item.userid}},[(item.nickname)?_c('span',[_vm._v(_vm._s(item.nickname))]):_vm._e(),_vm._v(" "),(item.realname)?_c('span',[_vm._v("/"+_vm._s(item.realname))]):_vm._e(),_vm._v(" "),(item.cellphone)?_c('span',[_vm._v("/"+_vm._s(item.cellphone))]):_vm._e(),_c('br')])],1)}),0):(scope.row.key === 'blackListTags' || scope.row.key === 'whiteListTags')?_c('span',_vm._l((scope.row.value),function(item){return _c('span',{staticClass:"blue-color"},[_vm._v("\n                  "+_vm._s(item.tagname)+"/"+_vm._s(item.id)),_c('br')])}),0):(scope.row.key === 'photo')?_c('span',_vm._l((scope.row.value),function(item){return _c('span',[_c('el-image',{staticStyle:{"width":"100px","cursor":"pointer"},attrs:{"src":item,"preview-src-list":scope.row.value,"alt":"爱零工"}})],1)}),0):(scope.row.key === 'adminname')?_c('span',[_c('span',[_vm._v(_vm._s(_vm.data.adminname)+"("+_vm._s(_vm.data.adminid)+")")])]):(scope.row.key === 'first_reviewer')?_c('span',[(_vm.data.first_reviewerid > 0)?_c('span',[_vm._v(_vm._s(_vm.data.first_reviewer_name)+"("+_vm._s(_vm.data.first_reviewerid)+")")]):_c('span')]):(scope.row.key === 'userprocesslog')?_c('span',[(scope.row.value)?_c('span',_vm._l((JSON.parse(scope.row.value)),function(item){return _c('span',[_c('span',[_vm._v(_vm._s(_vm.formatUnix(item.timestamp))+"\n                用户"),_c('router-link',{attrs:{"to":'/users/detail/info?userid='+item.userid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(item.userid))])]),_vm._v("\n                "+_vm._s(item.action)+"\n                ")],1),_c('br')])}),0):_vm._e()]):(scope.row.key === 'adminprocesslog')?_c('span',[(scope.row.value)?_c('span',_vm._l((JSON.parse(scope.row.value)),function(item){return _c('span',[_c('span',[_vm._v(_vm._s(_vm.formatUnix(item.timestamp))+"\n                "+_vm._s(item.adminname)+" "+_vm._s(item.action))]),_c('br')])}),0):_vm._e()]):(scope.row.key === 'templatejson')?_c('span',[_c('router-link',{attrs:{"to":'/order/review/'+_vm.data.orderid}},[_c('span',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.data.title))])])],1):(scope.row.key === 'checkinlocation')?_c('span',[_vm._v("\n              "+_vm._s(_vm.data.checkinlocation)+" (距离商场："+_vm._s(_vm.data.checkindistance)+"米)\n              ")]):(scope.row.key === 'finishlocation')?_c('span',[_vm._v("\n              "+_vm._s(_vm.data.finishlocation)+" (距离商场："+_vm._s(_vm.data.finishdistance)+"米)\n              ")]):(scope.row.key === 'userid')?_c('span',[(scope.row .value !== 0)?_c('span',{staticClass:"blue-color"},[_c('router-link',{attrs:{"to":'/users/table?keyword='+_vm.data.userid}},[(_vm.data.userinfo && _vm.data.userinfo.cellphone)?_c('span',{directives:[{name:"permission",rawName:"v-permission",value:([251]),expression:"[251]"}]},[_vm._v(_vm._s(_vm.data.userinfo.cellphone)+"/")]):_vm._e(),_vm._v(_vm._s(_vm.data.userid)+"\n              ")])],1):_vm._e()]):(scope.row.key === 'memo')?_c('span',[_c('order-memo-update',{attrs:{"orderid":_vm.data.orderid,"memo":_vm.data.memo}})],1):(scope.row.key === 'taskQuality' || scope.row.key === 'taskEfficiency')?_c('span',[_c('el-rate',{attrs:{"disabled":"","show-score":"","text-color":"#ff9900","score-template":"{value}"},model:{value:(_vm.data[scope.row.key]),callback:function ($$v) {_vm.$set(_vm.data, scope.row.key, $$v)},expression:"data[scope.row.key]"}})],1):(scope.row.key === 'content')?_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(scope.row.value)}})]):(scope.row.key === 'availableTime')?_vm._l((scope.row.value),function(availableTime){return _c('div',[_vm._v("\n                "+_vm._s(availableTime.starttime)+" - "+_vm._s(availableTime.endtime)+"\n              ")])}):(scope.row.key === 'face_verified')?_c('span',[_vm._l((_vm.options[scope.row.key]),function(item){return (scope.row.value === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()}),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":_vm.forcePass}},[_vm._v("手动通过")])],2):(scope.row.key === 'face_verified_image')?_c('span',[_c('order-face-verified',{attrs:{"orderid":_vm.data.orderid,"scoredFaceList":_vm.scoredFaceList,"image":scope.row.value}})],1):(scope.row.key === 'personface_verify')?_c('span',_vm._l((_vm.options[scope.row.key]),function(item){return (scope.row.value === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()}),0):(scope.row.key === 'addto_taskgroup_target_num')?_c('span',_vm._l((_vm.options[scope.row.key]),function(item){return (scope.row.value === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()}),0):_c('span',[_vm._v(_vm._s(scope.row.value))])]}}])})],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/order/table"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("返回\n          ")])],1),_vm._v(" "),(_vm.data.status === 4 || (_vm.data.status === 5 && _vm.data.type !== 8) || ((_vm.data.status === 2 || _vm.data.status === -1) && _vm.data.review > 0))?_c('router-link',{attrs:{"to":'/order/review/'+_vm.data.orderid}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[(_vm.data.status === 4)?_c('span',[_vm._v("审核")]):_vm._e(),_vm._v(" "),(_vm.data.status === 5)?_c('span',[_vm._v("修改审核")]):_vm._e(),_vm._v(" "),(((_vm.data.status === 2 || _vm.data.status === -1) && _vm.data.review > 0))?_c('span',[_vm._v("查看")]):_vm._e()])],1):_vm._e()],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("评论")]),_vm._v(" "),_c('issue-lighter',{attrs:{"order-id":_vm.data.orderid,"issue-id":_vm.data.issueid}})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-detail.b40e3df0d07f41a7367f.js